// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listFeedbackApiFeedbackGetParamsScopeDefault = `mine`;
export const listFeedbackApiFeedbackGetParamsStatusItemMax = 40;

export const listFeedbackApiFeedbackGetParamsStatusDefault = [];
export const listFeedbackApiFeedbackGetParamsStatusMax = 20;

export const listFeedbackApiFeedbackGetParamsCategoryItemMax = 40;

export const listFeedbackApiFeedbackGetParamsCategoryDefault = [];
export const listFeedbackApiFeedbackGetParamsCategoryMax = 20;

export const listFeedbackApiFeedbackGetParamsQOneMax = 200;

export const listFeedbackApiFeedbackGetParamsSortDefault = `last_activity_at`;
export const listFeedbackApiFeedbackGetParamsSortMax = 40;

export const listFeedbackApiFeedbackGetParamsOrderDefault = `desc`;
export const listFeedbackApiFeedbackGetParamsPageDefault = 1;

export const listFeedbackApiFeedbackGetParamsPageSizeDefault = 50;
export const listFeedbackApiFeedbackGetParamsPageSizeMax = 200;

export const ListFeedbackApiFeedbackGetParams = zod.object({
  "scope": zod.enum(['mine', 'all']).default(listFeedbackApiFeedbackGetParamsScopeDefault),
  "status": zod.array(zod.string().max(listFeedbackApiFeedbackGetParamsStatusItemMax)).max(listFeedbackApiFeedbackGetParamsStatusMax).default(listFeedbackApiFeedbackGetParamsStatusDefault),
  "category": zod.array(zod.string().max(listFeedbackApiFeedbackGetParamsCategoryItemMax)).max(listFeedbackApiFeedbackGetParamsCategoryMax).default(listFeedbackApiFeedbackGetParamsCategoryDefault),
  "q": zod.union([zod.string().max(listFeedbackApiFeedbackGetParamsQOneMax),zod.null()]).optional(),
  "sort": zod.string().max(listFeedbackApiFeedbackGetParamsSortMax).default(listFeedbackApiFeedbackGetParamsSortDefault),
  "order": zod.enum(['asc', 'desc']).default(listFeedbackApiFeedbackGetParamsOrderDefault),
  "page": zod.int().min(1).default(listFeedbackApiFeedbackGetParamsPageDefault),
  "page_size": zod.int().min(1).max(listFeedbackApiFeedbackGetParamsPageSizeMax).default(listFeedbackApiFeedbackGetParamsPageSizeDefault)
})

export type ListFeedbackApiFeedbackGetParams = zod.input<typeof ListFeedbackApiFeedbackGetParams>;
export type ListFeedbackApiFeedbackGetParamsOutput = zod.output<typeof ListFeedbackApiFeedbackGetParams>;
